import React, { Component } from "react";
import List from "./EquipmentTrackerList";
import Edit from "./EquipmentTrackerEdit";

export default class Tracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null,
      name: "",
      eno: ""
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return (
        <List
          onClick={this.handleClick}
          name={this.state.name}
          eno={this.state.eno}
        />
      );
    } else {
      return (
        <Edit
          pData={this.state.data}
          name={this.state.name}
          eno={this.state.eno}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data, name, eno) {
    this.setState({ data, mode, name, eno });
  }
}
